
const AppRouterPath = {
  booking: 'booking',
}

export default { AppRouterPath };
